export const onlyDigits = (value, maxLength) => {
    const sanitized = (value || '').replace(/\D/g, '');
    return maxLength ? sanitized.slice(0, maxLength) : sanitized;
};

export const phoneValue = (value) => {
    return (value || '').replace(/[^\d+]/g, '').slice(0, 14);
};

export const normalizeInputValue = (event, normalizer) => {
    event.target.value = normalizer(event.target.value);
};

const ruleMessages = {
    dni: 'El DNI debe tener 8 dígitos.',
    cuit: 'El CUIT debe tener 11 dígitos, sin guiones.',
};

export const validateControlledValue = (rule, value) => {
    const sanitizedValue = value || '';

    switch (rule) {
        case 'dni':
            return /^\d{8}$/.test(sanitizedValue) ? null : ruleMessages.dni;
        case 'cuit':
            return /^\d{11}$/.test(sanitizedValue) ? null : ruleMessages.cuit;
        default:
            return null;
    }
};

export const validateInputElement = (input) => {
    const validation = input.getAttribute('data-validation');
    return validateControlledValue(validation, input.value);
};

export const setInputFeedback = (input, message) => {
    if (message) {
        input.classList.add('is-invalid');
    } else {
        input.classList.remove('is-invalid');
    }

    const parent = input.parentElement;
    if (!parent) return;

    const feedback = Array.from(parent.children).find(child => child.classList.contains('invalid-feedback'));
    if (feedback) {
        feedback.innerHTML = message || '';
    }
};

export const validationInputProps = {
    dni: {
        maxLength: 8,
        inputMode: 'numeric',
        'data-validation': 'dni',
        onChange: (event) => normalizeInputValue(event, value => onlyDigits(value, 8)),
    },
    cuit: {
        maxLength: 11,
        inputMode: 'numeric',
        'data-validation': 'cuit',
        onChange: (event) => normalizeInputValue(event, value => onlyDigits(value, 11)),
    },
};



// WEBPACK FOOTER //
// ./src/utils/inputValidation.js